export const CHAT_SOCKET_EVENTS = {
  connect: 'connect',
  close: 'close',
  message: 'message',
  error: 'error',
};
